import { render } from "./MainLayout.vue?vue&type=template&id=095e4a0e"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/candidate/MainLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "095e4a0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('095e4a0e', __exports__)) {
    api.reload('095e4a0e', __exports__)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=095e4a0e", () => {
    api.rerender('095e4a0e', render)
  })

}


export default __exports__